import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { VehicleGrantMutations } from './vehicle_grant_mutations_container';
import { Company } from '../../company/entities';
import { InfiniteScroll } from '../../components/infinitescroll';
import {
  getNodes,
  PAGINATION_PAGE_SIZE,
  loadMoreFromConnection,
  CompanyRelationshipType,
  GrantRelationshipsListQuery as GrantRelationshipsListQueryResult,
  GrantRelationshipsListQueryVariables,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { VehicleGrantList, VehicleGrantListDataProps } from '../components/vehicle_grant_list';
import { grantRelationshipsQuery } from '../graphql';

class LoadingContainer extends Loader<
  GrantRelationshipsListQueryResult,
  VehicleGrantListDataProps,
  GrantRelationshipsListQueryVariables
> {}

interface VehicleGrantListContainerProps {
  company: Company;
}

export const VehicleGrantListContainer = (props: VehicleGrantListContainerProps) => {
  const { company_id } = useParams() as { company_id: string };

  const result = useQuery<GrantRelationshipsListQueryResult, GrantRelationshipsListQueryVariables>(
    grantRelationshipsQuery,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        companyId: company_id,
        sourceCompanyId: company_id,
        relationshipType: CompanyRelationshipType.SUBCARRIER,
        limit: PAGINATION_PAGE_SIZE,
      },
    },
  );

  return (
    <VehicleGrantMutations>
      {({ createVehicleGrants, revokeVehicleGrants }) => (
        <LoadingContainer
          result={result}
          mapData={({ data }) => ({
            data: {
              companyRelationships: getNodes(data.companyRelationships),
              company_id,
              company: props.company,
            },
          })}>
          {({ data }) => (
            <InfiniteScroll
              triggerOnWindow={false}
              loadMoreEntries={() => loadMoreFromConnection(grantRelationshipsQuery, result, ['companyRelationships'])}>
              <VehicleGrantList
                data={data}
                createVehicleGrants={createVehicleGrants}
                revokeVehicleGrants={revokeVehicleGrants}
              />
            </InfiniteScroll>
          )}
        </LoadingContainer>
      )}
    </VehicleGrantMutations>
  );
};
